export default "__VITE_ASSET__Df85Acch__"